<script>
import SkiDatePicker from './SkiDatePicker';

export default {
  name: 'SkiDiscount',
  components: {
    SkiDatePicker,
  },
  props: {
    discount: {
      type: Object,
      required: true,
    },
    availablePersonCategories: {
      type: Array,
      required: true,
    },
    seasonId: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      discountItem: Object.assign({}, this.discount),
      personCategories: this.discount.personCategories,
      percentageLimitTexts: [
        val => val < 100 || 'This is free. Wow',
        val => val < 80 || 'This is almost free now ?',
        val => val < 50 || 'Big discount',
      ],
    };
  },
  methods: {
    allowedBookDates(date) {
      return date > this.discountItem.bookFrom;
    },
    allowedArrivalDates(date) {
      return date > this.discountItem.arrivalFrom;
    },
    onDiscountChange(params) {
      this.$emit('onChange', {
        discountItem: {
          ...this.discountItem,
          minPax: parseInt(this.discountItem.minPax, 10),
          maxPax: parseInt(this.discountItem.maxPax, 10),
        },
        params,
      });
    },
  },
  watch: {
    discount: {
      deep: true,
      handler() {
        this.discountItem = Object.assign({}, this.discount);
      },
    },
  },
  computed: {
    getDiscountHeader() {
      return this.discountItem.id
        ? this.$t('ski.skiDiscount.discountNumber', {
          discountId: this.discountItem.id,
        })
        : this.$t('ski.skiDiscount.new');
    },
  },
};
</script>

<template>
  <v-container class="pa-3">
    <v-layout>
      <v-flex xs12 md9>
        <h3 :class="{'red--text': !discountItem.id}">
          {{ getDiscountHeader }}
          <span v-if="discountItem.percentage">
            ({{ discountItem.percentage }} %)
          </span>
        </h3>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md8 offset-xs1>
        <v-slider
          @input="onDiscountChange({ percentage: $event })"
          v-model="discountItem.percentage"
          :rules="percentageLimitTexts"
          :label="$t('ski.skiDiscount.percentage')"
          :disabled="loading || saveLoading"
          color="green"
          min="0"
          max="100"
          thumb-label="always"
          always-dirty
          persistent-hint
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md2 offset-xs1>
        <ski-date-picker
          @onChange="onDiscountChange({ bookFrom: $event })"
          :date.sync="discountItem.bookFrom"
          :title="$t('ski.skiDiscount.bookFrom')"
          :disabled="loading || saveLoading"
        />
      </v-flex>
      <v-flex xs12 md2>
        <ski-date-picker
          @onChange="onDiscountChange({ bookTo: $event })"
          :date.sync="discountItem.bookTo"
          :allowed-dates="allowedBookDates"
          :title="$t('ski.skiDiscount.bookTo')"
          :disabled="discountItem.bookFrom === undefined || loading || saveLoading"
        />
      </v-flex>
      <v-flex xs12 md2>
        <ski-date-picker
          @onChange="onDiscountChange({ arrivalFrom: $event })"
          :date.sync="discountItem.arrivalFrom"
          :title="$t('ski.skiDiscount.arrivalFrom')"
          :disabled="loading || saveLoading"
        />
      </v-flex>
      <v-flex sm2 xs2>
        <ski-date-picker
          @onChange="onDiscountChange({ arrivalTo: $event })"
          :date.sync="discountItem.arrivalTo"
          :allowed-dates="allowedArrivalDates"
          :title="$t('ski.skiDiscount.arrivalTo')"
          :disabled="discountItem.arrivalFrom === undefined || loading || saveLoading"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md2 offset-xs1>
        <v-text-field
          @input="onDiscountChange({ code: $event })"
          v-model="discountItem.minPax"
          label="Min. pax"
          type="number"
          :disabled="loading || saveLoading"
        />
      </v-flex>
      <v-flex xs12 md2 offset-xs1>
        <v-text-field
          @input="onDiscountChange({ code: $event })"
          v-model="discountItem.maxPax"
          label="Max. pax"
          type="number"
          :disabled="loading || saveLoading"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md8 offset-xs1>
        <v-select
          v-if="discount.id && availablePersonCategories.length"
          v-model="personCategories"
          @input="$emit('syncSelectedPersonCategories', personCategories, discountItem)"
          :items="this.availablePersonCategories"
          :disabled="saveLoading"
          :loading="loading"
          :deletable-chips="true"
          :label="$t('ski.skiDiscount.applyDiscountForPersonCategories')"
          item-text="name"
          item-value="id"
          chips
          multiple
        />
        <span v-if="!availablePersonCategories.length">
          <v-btn
            :to="`/ski/rental/season/${this.seasonId}/person-categories`"
            class="mb-2"
            color="warning"
            small
            outline
          >
            {{ $t('ski.skiPersonCategories.addMissingPersonCategories') }}
          </v-btn>
        </span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="text-xs-right">
        <v-btn
          @click="$emit('remove', discountItem.id)"
          :disabled="saveLoading"
          class="mb-2"
          color="error"
          outline
        >
          {{ $t('ski.skiDiscount.remove') }}
        </v-btn>
        <v-btn
          @click="$emit('createOrUpdate', discountItem)"
          :disabled="saveLoading"
          class="mb-2"
          color="green"
          outline
        >
          {{ discountItem.id ? $t('buttons.save') : $t('buttons.create') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/ski/rental/SkiDiscount.vue